export const environment = {
  production: false,
  apiUrl: 'https://dev-update32.freedompro.eu/api', // API URL per l'ambiente di sviluppo
  login: 'https://dev-update32.freedompro.eu/auth/github',
  debug: true,
};
